import React, { ReactElement } from 'react';
import { FormControl, FormHelperText, FormLabel, Input, Select } from '@chakra-ui/react';
import { FormFieldProps } from '../types';

const FormField = ({
  label,
  name,
  component: Component,
  type = 'text', // Default type is text
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  touched,
  helperText,
  options,
  ...props
}: FormFieldProps): ReactElement => {
  return (
    <FormControl isInvalid={!!error && touched}>
      <FormLabel fontSize="sm" fontWeight="400" lineHeight="normal" color="gray.900">
        {label} {props.required && <span style={{ color: 'red' }}>*</span>}
      </FormLabel>
      <Component
        _placeholder={{ fontSize: 'sm', fontWeight: 300, lineHeight: 'normal' }}
        fontSize="sm"
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        type={Component === Input ? type : undefined} // Add type only for Input component
        // eslint-disable-next-line react/no-children-prop
        children={
          Component === Select
            ? options?.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))
            : undefined
        }
        {...props}
      />

      {helperText && <FormHelperText fontSize="xs">{helperText}</FormHelperText>}
      {error && touched && (
        <FormHelperText fontSize="xs" color="red.500">
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FormField;
